import { Company } from '@/api';
import { createContext } from 'react';

export interface NullableCompanyContextData {
    company: Company | null;
    setCompany: (id: string) => void;
}
export const NullableCompanyContext = createContext<
    NullableCompanyContextData | undefined
>(undefined);
